import React from "react";
import { Card, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { convertIsoToDate } from "@/utils";
import { useScanQrcodeStore } from "@/store";

type IStampStatus =
  | "new"
  | "product_assigned"
  | "sold"
  | "activated"
  | "warranty_processing"
  | "warranty_replaced"
  | "blocked"
  | "processing";

type ITagType = "cyan" | "blue" | "gold" | "success" | "green" | "purple" | "red" | "orange" | "geekblue";

interface CustomTagProps {
  title: string;
  type: ITagType;
}

const CustomTag: React.FC<CustomTagProps> = ({ title, type }) => {
  const colorMap = {
    cyan: "cyan",
    blue: "blue",
    gold: "gold",
    success: "green",
    green: "green",
    purple: "purple",
    red: "red",
    orange: "orange",
    geekblue: "geekblue",
  };

  return (
    <Tag color={colorMap[type]} className="!m-0">
      {title}
    </Tag>
  );
};

const DistributionInfo: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const { stamp_code } = useScanQrcodeStore();

  const { serial, status, order, purchase_order, agency, sale_order } = stamp_code || {};

  const renderColorStatus = (status: IStampStatus): ITagType => {
    switch (status) {
      case "new":
        return "cyan";
      case "product_assigned":
        return "blue";
      case "sold":
        return "gold";
      case "activated":
        return "success";
      case "warranty_processing":
        return "green";
      case "warranty_replaced":
        return "purple";
      case "blocked":
        return "red";
      case "processing":
        return "orange";
      default:
        return "geekblue";
    }
  };

  const InfoRow: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <div className="grid grid-cols-12 gap-4 mb-3">
      <div className="col-span-5">{label}</div>
      <div className="col-span-7 text-right text-[#463E37] font-semibold">{value}</div>
    </div>
  );

  return (
    <Card title={<div className="text-[#F38020] text-[16px] font-bold">Thông tin phân phối</div>} className={className}>
      <div>
        <InfoRow label="Serial" value={serial || "--"} />

        <InfoRow
          label="Trạng thái tem"
          value={
            <CustomTag
              title={status ? t(`stamp_status.${status}`) : "--"}
              type={renderColorStatus(status as IStampStatus)}
            />
          }
        />

        <InfoRow label="Lô hàng" value={order?.name || "--"} />

        <InfoRow label="Kho nhập" value={purchase_order?.warehouse?.name || "--"} />

        <InfoRow
          label="Ngày nhập kho"
          value={purchase_order?.order_date ? convertIsoToDate(purchase_order.order_date) : "--"}
        />

        <InfoRow label="Đại lý phân phối" value={agency?.name || "--"} />

        <InfoRow
          label="Ngày xuất kho"
          value={sale_order?.order_date ? convertIsoToDate(sale_order.order_date) : "--"}
        />
      </div>
    </Card>
  );
};

export default DistributionInfo;
